import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './edipart.actions.js';
import getters from './edipart.getters.js';
import mutations from './edipart.mutations.js';
import state from './edipart.state.js';

BaseStore.registerModule('edipart', {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('edipart');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
